import React, { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [authState, setAuthState] = useState(() => {
    // Attempt to get an initial auth state from local storage
    const savedState = localStorage.getItem("authState");
    return savedState ? JSON.parse(savedState) : null;
  });

  const login = (authToken, user, graphAPIToken = null) => {
    const newState = { authToken, user, graphAPIToken };
    console.log("newState", newState);
    setAuthState(newState);
    localStorage.setItem("authState", JSON.stringify(newState));
  };

  const logout = () => {
    console.log("logout");
    setAuthState(null);
    localStorage.removeItem("authState");
  };

  useEffect(() => {
    const recheckAuthState = localStorage.getItem("authState");
    if (recheckAuthState) {
      setAuthState(JSON.parse(recheckAuthState));
    }
  }, []);

  return <AuthContext.Provider value={{ authState, login, logout }}>{children}</AuthContext.Provider>;
}
AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export const useAuth = () => useContext(AuthContext);
